import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function(name){
    try {
        const token =  Vue.$cookies.get("token");
        if(!token) return null;
        let data = await client.put("/user", {
            name: name
        }, {
            headers:{
                authorization: token
            }
        })
    return data
    } catch (error) {
        
    }
    return null   
}